import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import registers from './registers'
import crypto from 'crypto'
import axios from 'axios'

const gApi = axios.create();

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {auth, registers},
  state: {
    loading: {
      stats: false,
      message: 'carregando',
    },
    alerts: [],
    lastAlert: 'Avisos',
    snackbar: {
      stat: false,
      text: '',
      color: 'info',
      timeout: 3000,
    },
    drawer: false,
    drawerRight: false,
    drawerForm: false,
    fixNDR: false,
    demo: false,
    companies: [],
    companySelected: {},
    // erpEntities: {
    //   gpEmpresa: {
    //     cod: '010',
    //     nome: 'Teste',
    //   },
    //   filial: {
    //     cod: '03',
    //     nome: 'Teste'
    //   }
    // },
    collectionStructure: null,
    algolia: null,
    prothues: null
  },
  mutations: {
    setLoading (state, payload) { state.loading = payload },
    pushAlert (state, payload) { 
      state.alerts.push(payload) 
      state.lastAlert = payload.type 
    },
    showSnackbar (state, payload) { 
      state.snackbar = payload 
      state.snackbar.stat = true 
    },
    setDrawer (state, payload) { state.drawer = payload },
    setDrawerRight (state, payload) { state.drawerRight = payload },
    setFixNDR (state, payload) { state.fixNDR = payload },
    setDrawerForm(state, payload) { state.drawerForm = payload },
    setDemo (state, payload) { state.demo = payload },
    setCollectionStructure (state, payload) { state.collectionStructure = payload },
    setAlgolia (state, payload) { state.algolia = payload },
    setProtheus (state, payload) { state.protheus = payload },
    setCompanies (state, payload) { state.companies = payload },
    setCompanySelect (state, payload) { 
      state.companySelected = payload 
      this._vm.$api.defaults.params = {
        gpEmpresa: payload.M0_CODIGO+'0',
        filial: payload.M0_CODFIL
      }
    }
  },
  actions: {
    // GENERAL
    async initSystem({state, commit, dispatch}, {$router}) {
      dispatch('auth/authChanged', {$router}, {root: true})
    },
    async getConfigs({commit, dispatch}, {user}) {
      const companies = await dispatch('registers/get', { collection: 'sigamat', register: 'companies' }, {root: true})      
      commit('setCompanies', companies) 
      commit('setCompanySelect', companies.filter(x => user.companies.includes(x.id))[0]) 
      commit('setCollectionStructure', await dispatch('registers/getById', { collection: '_configs', register: '_configs', id: 'collectionStructure', setRegister: false }, {root: true})) 
      commit('setAlgolia', await dispatch('registers/getById', { collection: '_configs', register: '_configs', id: 'algolia', setRegister: false }, {root: true}))
      commit('setProtheus', await dispatch('registers/getById', { collection: '_configs', register: '_configs', id: 'protheus', setRegister: false }, {root: true}))
    },
    async changeCompany({state, commit, dispatch, rootState}, {$router, company}) {
      const oldCompany = this._vm.$_.cloneDeep(state.companySelected)
      
      commit('setCompanySelect', company) 
  
      // Update User
      await dispatch('auth/updateUser', {}, {root:true}) 
  
      this._vm.$integrations.forEach(integration => {
        const {register} = integration
        if (
          (
            // state.collectionStructure[register].gpEmpresa === 'e'
            // &&
            oldCompany.M0_CODIGO !== company.M0_CODIGO
          )
          ||
          state.collectionStructure[register].filial === 'e'
        ) {
          // Reset Observers e Registers
          if (rootState.registers.observers[register]) {
            rootState.registers.observers[register].snapshots.forEach(el => {
              el()
            });
          }
          commit('registers/resetRegister', register, { root: true }) 

          let {collection, filters = '', orderBy = '', details} = integration
          try {
            if (['{', '['].some(symbol => orderBy.includes(symbol)))
              orderBy = JSON.parse(orderBy)
          } catch (e) {
            console.warn(`Error when trying to define "orderBy" in changeCompany ${integration.name}.`, e)
          }
          try {
            filters = (integration.filters) ? JSON.parse(integration.filters) : null
          } catch (e) {
            console.warn(`Error when trying to define "filters" in changeCompany ${integration.name}.`, e)
          }

          // Start Observers
          dispatch('registers/observer', {
            collection: collection, 
            register: register, 
            filters: filters,
            orderBy: orderBy,
            details: details
          }, {root: true})
        }
      });

      if ($router.history.current.path.includes('/cadastrar')) $router.push($router.history.current.path.replace('/cadastrar', '/listar'))
    },
    dispatchAction({dispatch}, {action, params}) {
      dispatch(action, params, { root: true })
    },
    notify({}, {title, body, image, badge, icon, toast = true}) {
      this._vm.$notification.show(title, {
        lang: 'PT',
        body,
        image,
        badge,
        icon,
      }, {})
      if (toast) { this._vm.$toast.info(`${title} - ${body}`) }
    },
    gravatarUrl({}, email) {
      let hash = crypto.createHash('md5').update(email || '').digest("hex")
      return `https://www.gravatar.com/avatar/${hash}?s=200&d=mm&r=g`
    },
    downloadFileByUrl({}, {url, type, label}) {
      gApi.get(url, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: response.data.type })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = label
          link.click()
          URL.revokeObjectURL(link.href)
        }).catch(e => console.error(e))
    },
  }
})
